import { ref } from 'vue'

export const selectedPatient = ref(null)

export const setSelectedPatient = (payload) => {
    selectedPatient.value = payload
}

export const clearSelectedPatient = () => {
    selectedPatient.value = null
}